import Popper from '../base/popper'
import Vue from 'vue'

const PREFIXCLS = 'tooltip'
function getComponentChild (children) {
  return children && children.filter(c => c && c.tag)
}
export default {
  name: 'TTooltip',
  mixins: [ Popper ],
  props: {
    placement: {
      validator (value) {
        return [ 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end' ].includes(value)
      },
      default: 'bottom'
    },
    content: {
      type: [ String, Number ],
      default: ''
    },
    delay: {
      type: Number,
      default: 100
    },
    disabled: {
      type: Boolean,
      default: false
    },
    controlled: { // under this prop,Tooltip will not close when mouseleave
      type: Boolean,
      default: false
    },
    always: {
      type: Boolean,
      default: false
    },
    ellipsis: {
      type: Boolean,
      default: false
    },
    tabable: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 200
    }
  },
  data () {
    return {
      prefixCls: PREFIXCLS,
      popperEl: null,
      referenceVnode: null
    }
  },
  created () {
    const _this = this
    let app = Vue.extend({
      data () {
        return {
          prefixCls: PREFIXCLS,
          disabled: _this.disabled,
          visible: _this._visible,
          always: _this.always,
          ellipsis: _this.ellipsis,
          content: _this.content,
          maxWidth: _this.maxWidth
        }
      },
      computed: {
        innerclasses () {
          return [ `${this.prefixCls}-inner`, {
            [`text-truncate`]: _this.ellipsis
          }]
        }
      },
      template: `<transition name="fade">
        <div :class="prefixCls" ref="popper" v-show="!disabled && (visible || always)">
          <div :class="[prefixCls + '-content']">
            <div :class="[prefixCls + '-arrow']"></div>
            <div :class="innerclasses" :style="{'max-width':maxWidth + 'px'}">
              <slot name="content">{{ content }}</slot>
            </div>
          </div>
        </div>
      </transition>`
    })
    this.popperEl = new app()
    if (this.$slots.content) {
      this.popperEl.$slots.content = this.$slots.content
    }
    if (this.always && !this.disabled) {
      this.popperEl.$set(this.popperEl.$data, 'visible', true)
    }
  },
  watch: {
    disabled (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'disabled', val)
      }
    },
    visible (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'visible', val)
      }
    },
    always (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'always', val)
        if (!this.disabled) {
          this.popperEl.$set(this.popperEl.$data, 'visible', val)
        }
      }
    },
    content (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'content', val)
      }
      this.$_attachPoper()
    },
    ellipsis (val) {
      if (this.popperEl) {
        this.popperEl.$set(this.popperEl.$data, 'ellipsis', val)
      }
    }
  },
  // 使用render方式来渲染tooltip的触发元素,对应popperjs里的reference
  render (h) {
    if (!this.$slots.default || !this.$slots.default.length) return this.$slots.default
    const vnodeLength = getComponentChild(this.$slots.default).length
    let vnode = null
    if (vnodeLength === 1) {
      vnode = this.$slots.default[0]
    } else {
      vnode = h('div', {'class': {'d-inline-block': true}}, this.$slots.default)
    }
    if (!vnode) return vnode
    /**
     * vnode 对象参数（https://segmentfault.com/a/1190000008291645）
     */
    vnode.data = vnode.data || {}
    const on = vnode.data.on = vnode.data.on || {}
    const nativeOn = vnode.data.nativeOn = vnode.data.nativeOn || {}
    nativeOn.mouseenter = on.mouseenter = this.addEventHandle(on.mouseenter, this.$_onShowPopper)
    nativeOn.mouseleave = on.mouseleave = this.addEventHandle(on.mouseleave, this.$_onClosePopper)
    nativeOn.focus = on.focus = this.addEventHandle(on.focus, this.$_onShowPopper)
    nativeOn.blur = on.blur = this.addEventHandle(on.blur, this.$_onClosePopper)
    return vnode
  },
  mounted () {
    this.$_attachPoper()
    if (this.$slots.default && this.$slots.default[0] && this.$slots.default[0].tag) {
      this.$refs.reference = this.$slots.default[0].elm
    }
    if (this.$el.nodeType === 1 && this.tabable) {
      // 设置tab属性，使其能够根据tab来切换
      this.$el.setAttribute('tabindex', 0)
    }
    if (this.always) {
      this.visible = true
    }
  },
  methods: {
    $_attachPoper() {
      if (this.$slots.content && !this.content) {
        this.popperEl.$slots.content = this.$slots.content
      }
      if ((this.$slots.content || this.content !== '') && !this.popperEl.$el) {
        this.popperEl.$mount()
        this.$refs.popper = this.popperEl.$el
      }
    },
    addEventHandle (old, fn) {
      if (!old) {
        return fn
      } else if (Array.isArray(old)) {
        return old.indexOf(fn) > -1 ? old : old.concat(fn)
      } else {
        return old === fn ? old : [old, fn]
      }
    },
    $_onShowPopper (e) {
      this.$_attachPoper()
      let that = this
      if (this.disabled === true) {
        return
      }
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(() => {
        that.visible = true
      }, this.delay)
    },
    $_onClosePopper (e) {
      clearTimeout(this.timeout)
      if (!this.controlled && !this.always) {
        this.visible = false
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tooltip/tooltip.js